import React, { Component } from 'react';

import { TRIM_BOUND_DEACTIVATE_TIMEOUT } from 'constants/trimming';

import './styles.less';

export const FLAG_LEFT_HALF = 'left';
export const FLAG_RIGHT_HALF = 'right';
export const FLAG_WIDTH = 14;
export const EXPANDED_FLAG_WIDTH = 26;

class TrimFlag extends Component {
  mouseLeaveTimeout = null;
  state = { show_scrubber_time: false };

  render() {
    const { expandScrubber, half, visualHalf } = this.props;

    let scrubberClass = '';

    if (expandScrubber) {
      scrubberClass = 'expanded';
    }

    return (
      <div
        className={`video-player-trim-flag ${half} visual-${visualHalf} ${scrubberClass}`}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <div
          className="flag-scrubber"
          ref={scrubber => (this.scrubber = scrubber)}
          onTransitionEnd={this.showScrubberTime}
        />
        <span className="flag-pole" />
      </div>
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.expandScrubber !== this.props.expandScrubber) {
      window.clearTimeout(this.mouseLeaveTimeout);
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.mouseLeaveTimeout);
  }

  componentDidMount() {
    this.showScrubberTime();
  }

  handleMouseDown = e => {
    e.stopPropagation();

    window.clearTimeout(this.mouseLeaveTimeout);

    document.addEventListener('mousemove', this.handleMouseMove, true);
    document.addEventListener('mouseup', this.handleMouseUpWithoutUpdate, true);

    this.props.onMouseDown();
  };

  handleMouseMove = e => {
    document.addEventListener('mouseup', this.handleMouseUpWithUpdate, true);
    document.removeEventListener(
      'mouseup',
      this.handleMouseUpWithoutUpdate,
      true
    );

    this.props.onUpdateTime(e, this.props.half);
  };

  handleMouseUp(e, updateTrimRange = false) {
    document.removeEventListener('mousemove', this.handleMouseMove, true);
    document.removeEventListener('mouseup', this.handleMouseUpWithUpdate, true);
    document.removeEventListener(
      'mouseup',
      this.handleMouseUpWithoutUpdate,
      true
    );

    // collapse the flag
    this.onMouseLeave();

    if (!updateTrimRange) {
      return;
    }

    this.props.onUpdateTime(e, this.props.half);
  }

  handleMouseUpWithUpdate = e => {
    this.handleMouseUp(e, true);
  };

  handleMouseUpWithoutUpdate = e => {
    this.handleMouseUp(e, false);
  };

  handleTimeChange = newTime => {
    this.props.onUpdateTime(null, this.props.half, newTime);

    // reset the timeout for flag collapsing
    this.onMouseLeave();
  };

  onMouseLeave = async () => {
    window.clearTimeout(this.mouseLeaveTimeout);

    // give it 3 seconds before collapsing
    await new Promise(resolve => {
      this.mouseLeaveTimeout = window.setTimeout(
        resolve,
        TRIM_BOUND_DEACTIVATE_TIMEOUT
      );
    });

    if (this.scrubber && this.scrubber.querySelector(':hover') != null) {
      return;
    }

    this.props.onMouseLeave(this.props.half);
  };

  onMouseEnter = () => {
    this.props.onMouseEnter(this.props.half);
  };

  showScrubberTime = () => {
    this.setState({ show_scrubber_time: this.props.expandScrubber });
  };
}

export default TrimFlag;
